<template>
  <popup
    ref="popup"
    title="初始化环境"
    :width="500"
    :closable="false"
    openType="modal"
    @on-ok="onOk"
    :footer-hide="true"
    @on-visible-change="onVisibleChange"
  >
    <Progress :percent="args.percentage" :stroke-width="20" status="active" text-inside/>
    <div class="install-tip">{{ args.message }}</div>
  </popup>
</template>

<script>
import popup from "@/components/popup";

export default {
  components: {
    popup,
  },
  data() {
    return {
      args: {}
    };
  },
  methods: {
    open(args) {
      clearTimeout(this.timerId);

      this.$refs.popup.open();
      args.percentage = Number(args.percentage || 0);
      this.args = args;

      if (args.status === 2) {
        this.timerId = setTimeout(() => {
          this.$refs.popup.close();
        }, 1500);
      }
    },
    onOk() {
      this.$refs.popup.close();
    },
    onVisibleChange(e) {

    },
  },
};
</script>

<style scoped lang="less">
.install-tip {
  margin-top: 16px;
  font-size: 16px;
  color: #86909C;
}
</style>
